// extracted by mini-css-extract-plugin
export default {"container":"EmployedsFilterContainer_container__8GHpB","amount":"EmployedsFilterContainer_amount__KAJIL"};